module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_2.9c531768.png";